import Bugsnag from '@bugsnag/js';

// const log = error => Bugsnag.notify(error);
const log = error => console.log(error);
const setUser = (...params) => Bugsnag.setUser(...params);
const leaveBreadcrumb = (...params) => Bugsnag.leaveBreadcrumb(...params);

export default { log, setUser, leaveBreadcrumb };
